<template>
  <el-container>
    <el-header height="80px">
      <el-menu class="el-menu-demo" :default-active="activeIndex" mode="horizontal" id="elMenu" @select="handleSelect"  v-top-menu-scroll>
        <el-menu-item @click="back()">后退</el-menu-item>
        <el-menu-item index="/balingheSensorIndex">首页</el-menu-item>
        <!-- <el-menu-item index="/balingheSensor/highFrequencyDevice?bridgeId=6edcfe29-44ab-44c6-88b0-0f67c021a553">高频设备管理</el-menu-item>
          <el-menu-item index="/balingheSensor/highFrequencyDataTable?bridgeId=6edcfe29-44ab-44c6-88b0-0f67c021a553">高频实验数据表</el-menu-item> -->

        <el-submenu :index="'/balingheSensor/gasClamp'">
          <template slot="title">全桥实时数据</template>
          <el-menu-item index="/balingheSensor/gasClamp/up"> 南侧气夹实时数据 </el-menu-item>
          <el-menu-item index="/balingheSensor/gasClamp/down"> 北侧气夹实时数据 </el-menu-item>
          <el-menu-item index="/balingheSensor/cableClamp"> 索夹实时数据 </el-menu-item>
          <el-menu-item index="/balingheSensor/gasClamp/saddleAnchor"> 锚鞍室实时数据 </el-menu-item>
        </el-submenu>
        <el-submenu :index="'/balingheSensor/station'">
          <template slot="title">主缆除湿机组</template>
          <el-menu-item index="/balingheSensor/station/left"> 1#除湿机组(东-镇宁侧) </el-menu-item>
          <el-menu-item index="/balingheSensor/station/right"> 2#除湿机组(西-胜境关侧) </el-menu-item>
          <el-menu-item index="/balingheSensor/station/middle"> 3#除湿机组(跨中) </el-menu-item>
        </el-submenu>
        <el-submenu :index="'/balingheSensor/stationAnchorSaddle'">
          <template slot="title">锚鞍室除湿机组</template>
          <el-menu-item index="/balingheSensor/stationAnchorSaddle/leftAnchor"> 镇宁侧锚室 </el-menu-item>
          <el-menu-item index="/balingheSensor/stationAnchorSaddle/rightAnchor"> 胜境关侧锚室 </el-menu-item>
          <el-menu-item index="/balingheSensor/stationAnchorSaddle/leftSaddle"> 镇宁侧鞍室 </el-menu-item>
          <el-menu-item index="/balingheSensor/stationAnchorSaddle/rightSaddle"> 胜境关侧鞍室 </el-menu-item>
        </el-submenu>

        <el-submenu :index="'/balingheSensor/highFrequencyData?bridgeId=6edcfe29-44ab-44c6-88b0-0f67c021a553'">
          <template slot="title">高频试验</template>
          <el-menu-item index="/balingheSensor/highFrequencyData?bridgeId=6edcfe29-44ab-44c6-88b0-0f67c021a553"> 高频试验数据 </el-menu-item>
          <el-menu-item index="/balingheSensor/highFrequencyDevice?bridgeId=6edcfe29-44ab-44c6-88b0-0f67c021a553"> 高频提交管理 </el-menu-item>
        </el-submenu>
<!-- 
        <el-menu-item index="/balingheSensor/currentHumidityList?bridgeId=6edcfe29-44ab-44c6-88b0-0f67c021a553&sortByItemCount=1"
          >湿度数据清单</el-menu-item
        >
        <el-menu-item index="/balingheSensor/currentDataTable?bridgeId=6edcfe29-44ab-44c6-88b0-0f67c021a553">实时数据表</el-menu-item> -->

        <el-submenu :index="'/balingheSensor/currentHumidityList?bridgeId=6edcfe29-44ab-44c6-88b0-0f67c021a553&sortByItemCount=1'">
          <template slot="title">湿度数据清单</template>
          <el-menu-item index="/balingheSensor/currentHumidityList?bridgeId=6edcfe29-44ab-44c6-88b0-0f67c021a553&sortByItemCount=1"> 湿度数据清单 </el-menu-item>
          <el-menu-item index="/balingheSensor/currentDataTable?bridgeId=6edcfe29-44ab-44c6-88b0-0f67c021a553"> 实时数据表 </el-menu-item>
        </el-submenu>

        <el-menu-item index="/balingheSensor/errorRecord?bridgeId=6edcfe29-44ab-44c6-88b0-0f67c021a553">报警记录</el-menu-item>
        <el-submenu :index="'/balingheSensor/dataHistory?bridgeId=6edcfe29-44ab-44c6-88b0-0f67c021a553&scenarioId=TBD'">
          <template slot="title">数据历史</template>
          <el-menu-item index="/balingheSensor/dataHistory?bridgeId=6edcfe29-44ab-44c6-88b0-0f67c021a553&scenarioId=TBD"> 查询数据历史 </el-menu-item>
          <el-menu-item index="/balingheSensor/dataHistory?bridgeId=6edcfe29-44ab-44c6-88b0-0f67c021a553"> 自定义数据历史 </el-menu-item>
        </el-submenu>
      </el-menu>
      <HeaderTime bridgeName="GUANLING" :bridgeId="bridgeId" :id2Path="id2Path" :envInfo="envInfo"></HeaderTime>
    </el-header>
    <el-main class="el-main ba-ling-he">
      <router-view></router-view>
    </el-main>
  </el-container>
</template>
<script>

import topMenuScroll from '../../tools/TopMenuScroll.js'

export default {
  name: "balingheSensor",
  data() {
    return {
      bridgeId: "6edcfe29-44ab-44c6-88b0-0f67c021a553",
      envInfo: {
        envId: "37d03b17-c900-489f-af56-52cd0482e703",
        weather: "6b5cc6ef-3ca1-410a-8aa1-e63218f56c62",
        humidity: "22e08b86-dbe7-4afa-9a8b-c309963aa74f",
        temperature: "a9228795-5852-4700-8daa-9895d993be66",
        weatherAbsoluteHumidity: "b02cd92e-115c-4775-9009-ba652b655df7",
      },
      id2Path: {},
      activeIndex: "",
      historyScenarioList: [],
    };
  },
  mounted() {
    this.activeIndex = this.$route.fullPath;

    document.getElementById("elMenu").addEventListener(
      "mousewheel",
      (e) => {
        let scrollWidth = document.getElementById("elMenu").scrollWidth;
        let clientWidth = document.getElementById("elMenu").clientWidth;

        let scrollMin = 0;
        let scrollMax = scrollWidth - clientWidth;
        let step = 30;

        if (e.deltaY > 0) {
          document.getElementById("elMenu").scrollLeft += step;
          if (document.getElementById("elMenu").scrollLeft > scrollMax) {
            document.getElementById("elMenu").scrollLeft = scrollMax;
          }
        } else if (e.deltaY < 0) {
          document.getElementById("elMenu").scrollLeft += step * -1;
          if (document.getElementById("elMenu").scrollLeft < scrollMin) {
            document.getElementById("elMenu").scrollLeft = scrollMin;
          }
        }
      },
      true
    );
  },
  watch: {
    $route() {
      this.activeIndex = this.$route.fullPath;
    },
  },
  directives: {
    topMenuScroll,
  },
  methods: {
    back() {
      window.history.back();
    },
    handleSelect(key) {
      if (key !== this.activeIndex) {
        this.activeIndex = key;
        this.$router.push(key);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-menu-demo {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;

  overflow-x: scroll;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background: transparent;
  display: none;
}
</style>
